import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';

import { CommonService } from '@shared/services/common.service';
import { MetadataService, MetadataSlugs } from '@shared/services/metadata.service';

export type ReferenceStreamModeValue = 'accurate' | 'fast';

@Component({
  selector: 'app-reference-stream-mode',
  templateUrl: './reference-stream-mode.component.html',
  styleUrls: ['./reference-stream-mode.component.scss'],
  standalone: true,
  imports: [MatFormField, MatLabel, MatSelect, MatOption, FormsModule, MatButton],
})
export class ReferenceStreamModeComponent implements OnInit, OnDestroy {
  private _metadataService = inject(MetadataService);
  private _commonService = inject(CommonService);
  private _sub: Subscription | undefined;

  protected value: ReferenceStreamModeValue = 'fast';

  ngOnInit(): void {
    this._metadataService.get<string>(MetadataSlugs.ReferenceStreamMode).subscribe({
      next: metadata => {
        const v = metadata?.value;
        this.value = v === 'accurate' || v === 'fast' ? v : 'fast';
      },
      error: () => {
        this.value = 'fast';
      },
    });
  }

  protected save(): void {
    this._sub = this._metadataService
      .set(MetadataSlugs.ReferenceStreamMode, this.value)
      .subscribe({
        next: () => {
          this._commonService.openSuccessSnackBar('Reference stream mode saved.');
        },
        error: () => {
          this._commonService.openErrorSnackBar('Error saving reference stream mode.');
        },
      });
  }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
  }
}
